/* eslint linebreak-style: ["error", "windows"] */

import Responder from './_modules/Responder';
import MainMenu from './_modules/MainMenu';
import Toggle from './_modules/Toggle';
import StickyNav from './_modules/StickyNav';
import Tabs from './_modules/Tabs';

/* -------------------------------------------------------------------------- *
 * App Initialization *
 * -------------------------------------------------------------------------- */

Responder.init();

if (document.getElementsByClassName('js-menuProducts').length > 0) {
    MainMenu.init();
}

if (document.getElementsByClassName('js-toggle').length > 0) {
    Toggle.init();
}

if (document.getElementById('js-sentinel')) {
    StickyNav.init();
}

if (document.getElementsByClassName('js-tab').length > 0) {
    Tabs.init();
}
